import { waitUntil } from '@atc/wait-until';

/**
 * Configuration for vehicle reconditioning LS360 modal
 */
const RECONDITIONING_SELECTORS = {
    VEHICLE_RECONDITIONING: '#vehicle-reconditioning-differentiator-details',
    LS360_KEY: '179917CE-18CF-4CEE-9562-8EF99A01D423',
};

/**
 * Sets up LS360 vehicle reconditioning modal for DifferentiatorsDisplay
 * @param {string} fyuseId - The vehicle's fyuse ID
 * @returns {Function} Cleanup function to remove the element
 */
export const setupReconditioningModal = (fyuseId) => {
    if (!fyuseId) {
        return () => {};
    }

    // Wait for LS360 to be available, then set up our own reconditioning element
    waitUntil(
        () => typeof globalThis?.LS360 === 'function',
        () => {
            // Create our own reconditioning element if it doesn't exist
            let reconditioningElement = document.getElementById(RECONDITIONING_SELECTORS.VEHICLE_RECONDITIONING.substring(1));
            if (!reconditioningElement) {
                reconditioningElement = document.createElement('span');
                reconditioningElement.id = RECONDITIONING_SELECTORS.VEHICLE_RECONDITIONING.substring(1);
                reconditioningElement.style.display = 'none';
                document.body.appendChild(reconditioningElement);

                // Set up LS360 for our element
                globalThis.LS360(
                    RECONDITIONING_SELECTORS.LS360_KEY,
                    [RECONDITIONING_SELECTORS.VEHICLE_RECONDITIONING],
                    { val: fyuseId },
                    { button: 1, append: 1, leadButton: 1 }
                );
            }
        },
        100,
        5000
    );

    // Return cleanup function
    return () => {
        const element = document.getElementById(RECONDITIONING_SELECTORS.VEHICLE_RECONDITIONING.substring(1));
        if (element && document.body.contains(element)) {
            element.remove();
        }
    };
};

/**
 * Triggers the reconditioning modal by clicking the LS360 element
 * @returns {boolean} Whether the modal was successfully triggered
 */
export const triggerReconditioningModal = () => {
    const reconditioningElement = document.getElementById(RECONDITIONING_SELECTORS.VEHICLE_RECONDITIONING.substring(1));
    if (reconditioningElement) {
        reconditioningElement.click();
        return true;
    }
    return false;
};
